"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Button = exports.ButtonFixedPosition = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ButtonFixedPosition = _styledComponents.default.div.withConfig({
  displayName: "FloatingActionButtonstyle__ButtonFixedPosition",
  componentId: "sc-198pniy-0"
})(["position:fixed;", " bottom:", ";"], (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    right: ", ";\n  "])), function (_ref) {
  var theme = _ref.theme;
  return theme.space.md;
}), function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.md;
});
exports.ButtonFixedPosition = ButtonFixedPosition;
var Button = _styledComponents.default.button.withConfig({
  displayName: "FloatingActionButtonstyle__Button",
  componentId: "sc-198pniy-1"
})(["align-items:center;background:", ";border-radius:", ";box-shadow:", ";color:white;cursor:pointer;display:flex;font-size:", ";font-weight:", ";height:", ";letter-spacing:-0.1px;max-width:100%;padding:0 ", ";text-decoration:none;transition:all ", ";transform:translateY( ", " );pointer-events:", ";opacity:", ";width:auto;z-index:20;&:hover,&:active{background-color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.brandPrimary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.lg;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.elevation.lg;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.xs;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeight.bold;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.xxxl;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.md;
}, function (_ref10) {
  var animation = _ref10.theme.animation;
  return "".concat(animation.duration.medium, "ms ").concat(animation.cubicBezier.fastOutSlowIn);
}, function (_ref11) {
  var isHidden = _ref11.isHidden,
    theme = _ref11.theme;
  return isHidden ? theme.space.md : 0;
}, function (_ref12) {
  var isHidden = _ref12.isHidden;
  return isHidden ? 'none' : 'auto';
}, function (_ref13) {
  var isHidden = _ref13.isHidden;
  return isHidden ? '0' : '1';
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.brandPrimaryInteract;
});
exports.Button = Button;
var Text = _styledComponents.default.span.withConfig({
  displayName: "FloatingActionButtonstyle__Text",
  componentId: "sc-198pniy-2"
})(["user-select:none;"]);
exports.Text = Text;